import { render, staticRenderFns } from "./FlowPriorityNext.vue?vue&type=template&id=afe55e14"
import script from "./FlowPriorityNext.vue?vue&type=script&lang=js"
export * from "./FlowPriorityNext.vue?vue&type=script&lang=js"
import style0 from "./FlowPriorityNext.vue?vue&type=style&index=0&id=afe55e14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports